import React, { useContext, useEffect, useState } from 'react'
import { GlobalTable } from '../../../../../utility/globalTable'
import { Grid } from '@mui/material'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { GenericDataContext, GenericDataContextPayload } from '../../../../../../context/genericDataContext';
import { channelsBreadcrumb, homeBreadcrumb, whatsappFlowList } from '../../../../../../utils/breadcrumb';
import { getWabaName } from '../templates/utils';
import { IntegrationContext, IntegrationContextPayload } from '../../../../../../context/integrationContext';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import agent from '../../../../../../services/api';
import { WhatsappFlow } from './waFlowTypes';
import { formatDateAccordingToTimezoneUsingMoment } from '../../../../../../utils/constants';

function WhatsappFlowList() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams()
    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload;
    const { integrationListNewStructure, getWAFlowList, flowList, getMetaIntegrationList } = useContext(IntegrationContext) as IntegrationContextPayload;
    const { setFlagLoading, userDetail, handleError } = useContext(UserContext) as UserContextPayload
    const flowListColumns = [
        {
            name: "Flow Name",
            alignment: "left",
            flagIcon: false,
            valueKey: "whatsapp_flow_name",
            iconKey: "documentIco",
            sx: {
                padding: "14px 16px !important"
            }
        },
        {
            name: "Flow ID",
            alignment: "left",
            flagIcon: false,
            valueKey: "whatsapp_flow_meta_id",
            iconKey: "documentIco",
            sx: {
                padding: "14px 16px !important"
            },
            flagCopyOnHover: true
        },
        {
            name: "Status",
            alignment: "left",
            flagIcon: false,
            valueKey: "whatsapp_flow_meta_status",
            iconKey: "documentIco",
            sx: {
                padding: "14px 16px !important"
            }
        },
        {
            name: "Last Updated",
        alignment: "left",
            flagIcon: false,
            valueKey: "timestamp",
            iconKey: "documentIco",
            sx: {
                padding: "14px 16px !important"
            }
        }
    ]
    let wabaId = searchParams.get("id");
    const pathname = window.location.pathname.toLowerCase();

    useEffect(() => {
        if (wabaId) {
            const updatedBreadcrumbs = [
                homeBreadcrumb,
                channelsBreadcrumb,
                { name: getWabaName(integrationListNewStructure, wabaId), path: `/channels/viewintegration/Whatsapp?id=${wabaId}`, isActive: false, isSamePageRedirecting: pathname === "/channels/viewintegration/whatsapp" },
                { ...whatsappFlowList, isActive: true }
            ];
            setBreadCrumbs(updatedBreadcrumbs);
        } else {
            setBreadCrumbs([homeBreadcrumb, { ...channelsBreadcrumb }, { ...whatsappFlowList, isActive: true }]);
        }
    }, [wabaId, integrationListNewStructure])

    const getWAFlowListCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getWAFlowList(userDetail, wabaId ?? "");
        if(!res.status){
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        getWAFlowListCall();
        if(!integrationListNewStructure){
            getMetaIntegrationList(true);
        }
    }, [])

    const rowClicked = (e: any, rowDetail: any) => {
        navigate(`/channels/viewintegration/whatsapp/flowDetails?id=${wabaId}&flow_id=${rowDetail?.whatsapp_flow_id}`)
    }

    return (
        <Grid item xs={12} paddingBlock={2}>
            <GlobalTable
                headerList={flowListColumns}
                rowData={flowList ?? []}
                tableContainerMinHeight={"auto"}
                //   onCellClick={(e: any, rowDetail: any) => { handleOpenEditSection(e, rowDetail) }}
                //   rowClicked={rowClicked}
                onCellClick={(e: any, rowDetail: any) => { rowClicked(e, rowDetail) }}
                onRowClick={(e: any) => { console.log("hello", e) }}
                rowAllowEdit={false}
                flagPagination 
                tableHeight={"82vh"}
            //   menuItemsFromParent={menuItems}
            />
        </Grid>
    )
}

export default WhatsappFlowList